var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 7.49996C4.16675 4.7501 4.16675 3.37517 5.02102 2.5209C5.87529 1.66663 7.25022 1.66663 10.0001 1.66663C12.7499 1.66663 14.1248 1.66663 14.9792 2.5209C15.8334 3.37517 15.8334 4.7501 15.8334 7.49996V12.5C15.8334 15.2498 15.8334 16.6247 14.9792 17.479C14.1248 18.3333 12.7499 18.3333 10.0001 18.3333C7.25022 18.3333 5.87529 18.3333 5.02102 17.479C4.16675 16.6247 4.16675 15.2498 4.16675 12.5V7.49996Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 15.8334H10.8334",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.66663L7.57417 2.11164C7.7349 3.07603 7.81527 3.55823 8.14599 3.85166C8.491 4.15774 8.98008 4.16663 10 4.16663C11.0199 4.16663 11.509 4.15774 11.854 3.85166C12.1847 3.55823 12.2651 3.07603 12.4258 2.11164L12.5 1.66663",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.cd92c05722f408e214f6df16b9f700af.svg";
export { ForwardRef as ReactComponent };